import { createContext, ReactNode, useContext, useMemo } from "react";
import type { HTTPClientV3 } from "../dataAccess/HTTPClientV3";

export interface RequestData {
  host?: string | null;
  url: string | null;
  marketplaceNoAccounts: boolean | null;
}

export const ApiClientContext = createContext<
  { APIV3: HTTPClientV3 } | undefined
>(undefined);

interface Props {
  children: ReactNode;
  client: HTTPClientV3;
}

export const ApiClientProvider = ({ children, client }: Props) => {
  const value = useMemo(
    () => ({
      APIV3: client,
    }),
    [client],
  );
  return (
    <ApiClientContext.Provider value={value}>
      {children}
    </ApiClientContext.Provider>
  );
};

export function useApiClientContext() {
  const context = useContext(ApiClientContext);
  if (context === undefined) {
    throw new Error("Must be used within a ApiClientProvider");
  }
  return context;
}
